import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getLeaSpeakerData, setSpeakerInZone } from '../../../../action/roomControlAction'
import { setGoHome } from '../../../action/homeAction'
import SpeakerControl2 from './SpeakerControl2'
import { CLICKED, CMSPath, EXIT } from '../../../../config/constant'
import { calculateTimeDifference, getDefaultAnalyticsLabel } from '../../../JS/utility'
import { guestDetails, sendAnalytics } from '../../../../action/homeAction'
import Loader from '../../../UI/loader'
import { wipeGuestData } from '../../../../JS/wipeGuestData'

function SoundControl(props) {
	const [selectedSpeaker, setSelectedSpeaker] = useState(null)
	const [widgetLaunchTime, setWidgetLaunchTime] = useState(new Date)
    const [widgetName, setWidgetName] = useState(props.currentWidget.displayName)
	const [showLoader, setLoader] = useState(false)
    let locationId = localStorage.getItem("roomID");
	let SessionToken = localStorage.getItem("GuestJourneySessionToken");

	useEffect(() => {
		let speakerInZone = props.speakerInZone
		setLoader(true)
		props.guestDetails(SessionToken, wipeGuestData, props.guestDetail.guestToken);
		props.getLeaSpeakerData(locationId, (status, data) => {
			setLoader(false)
			data.zonesInfoList.map((zone) => {
				zone.zoneSlaves.map(slave => {
					if(!speakerInZone[zone.label] || speakerInZone[zone.label].length == 0){
						speakerInZone[zone.label] = [slave.identifierKey]
					} else {
						if(speakerInZone[zone.label] && !speakerInZone[zone.label].includes(slave.identifierKey)){
							speakerInZone[zone.label].push(slave.identifierKey)
						}
					}
				})
            })        
			setSpeakerInZone(speakerInZone)
		})
	  }, [])

	  useEffect(() => {

        let label = getDefaultAnalyticsLabel({appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : ""})
        // Send Analytics
        if(props.guestIsLoggedIn){
            props.sendAnalytics(
                props.guestDetail, 
                props.currentWidget.displayName, 
                CLICKED, 
                {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget"}, 
                0, 
                props.guestIsLoggedIn
            );
        }
        //

        return() => {
            // Send Analytics
            if(props.guestIsLoggedIn){
                console.log("sending analytics")
                let widgetCloseTime = new Date
                let duration = calculateTimeDifference(widgetLaunchTime, widgetCloseTime, 'second')
                props.sendAnalytics(
                    props.guestDetail, 
                    widgetName, 
                    EXIT, 
                    {...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "duration": duration}, 
                    0, 
                    props.guestIsLoggedIn
                );
            }
            // 
        }
    }, [])

  return (
	selectedSpeaker ? <SpeakerControl2 goBack={() => setSelectedSpeaker(null)} selectedSpeaker={selectedSpeaker} /> :
    <div class="main-container background-overlay">
		<header class="inner-pages subpages no-background">
			<a onClick={() => props.setGoHome(true)} class="button-back"></a>
			<div class="heading align-center">
                <div class="splash-brand">
                    <img src={`${CMSPath}${props.logo}`} />
                </div>
				{/* <p class="bold">Select Speaker</p> */}
			</div>
		</header>
		<section id="customizeRoom" class="widgets padding-bottom-2 margin-0">

                <div class="widget-header widget-header-checkin">
                    { props.currentWidget.widgetHeaderImageUrl && 
                        <div class="widget-header-img">
                            <img src={`${CMSPath}${props.currentWidget.widgetHeaderImageUrl}`} alt={props.currentWidget.displayName} />
                        </div>
                    }
                    <div class="widget-header-title">{props.currentWidget.displayName}</div>
                </div>


			<div class="widgets">
				<div class="row">
					<div class="col">
						<p class="heading">Select Speaker</p>
					</div>
				</div>
				<div class="row">
					<div class="col col-2 menu-items">
						{
                            props.speakerList && props.speakerList.map((speaker) =>
                                <a onClick={() => setSelectedSpeaker(speaker)} class="tile-sm thumbnails tile-container">
                                    <div class="thumb-img">
                                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 137.37 108.32"><title>ico_speaker</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M14.92,34.64H8.63A8.63,8.63,0,0,0,0,43.27V65.06a8.62,8.62,0,0,0,8.63,8.62h6.29Z"/><path class="cls-1" d="M64.57,54.16V6.49s.56-4.89-3.19-6.2S55,2.54,55,2.54L24.78,34.64v39L55,105.78s2.63,3.57,6.38,2.25,3.19-6.19,3.19-6.19Z"/><path class="cls-1" d="M92.13,54.16s.33-12.32-8.83-21.07l-8.19,8.19s5.51,4.21,5.51,12.88-5.51,12.89-5.51,12.89l8.19,8.19C92.46,66.48,92.13,54.16,92.13,54.16Z"/><path class="cls-1" d="M91.08,82.85l8.43,8c16-15.65,14.91-36.64,14.91-36.64s1.14-21-14.91-36.63l-8.43,7.94a41.47,41.47,0,0,1,11.83,28.69A41.47,41.47,0,0,1,91.08,82.85Z"/><path class="cls-1" d="M125.77,54.16c0,27.24-18.24,44.42-18.24,44.42l8.43,8c22.62-23,21.4-52.44,21.4-52.44S138.58,24.74,116,1.72l-8.43,8S125.77,26.93,125.77,54.16Z"/></g></g></svg>
                                    </div>
                                    <div class="thumb-text align-center">
                                        <p class="thumb-heading">{speaker.label}</p>
                                    </div>
                                </a>
                            )
                        }
					</div>
				</div>
			</div>
		</section>
		{showLoader && <Loader displayMsg={"Fecthing data..."}/>}
    </div>
  )
}

const mapStateToProps = (state) => {
	return {
		speakerList: state.store.leaSpeakerData.slavedevicesList,
		leaSpeakerData: state.store.leaSpeakerData,
		speakerInZone: state.store.speakerInZone,
		guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidget: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
	}
}

const mapDispatchToProps = dispatch => {
	return bindActionCreators({getLeaSpeakerData, setGoHome, setSpeakerInZone, sendAnalytics, guestDetails}, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SoundControl);